var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 109,
    viewBox: "0 0 380 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 33.9439C30 30.6612 32.6612 28 35.9439 28H58.0561C61.3388 28 64 30.6612 64 33.9439V109H30V33.9439Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71 53.9439C71 50.6612 73.6612 48 76.9439 48H98.0561C101.339 48 104 50.6612 104 53.9439V109H71V53.9439Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111 10.9439C111 7.66118 113.661 5 116.944 5H139.056C142.339 5 145 7.66119 145 10.9439V109H111V10.9439Z",
    fill: "#FF8816"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152 83.9439C152 80.6612 154.661 78 157.944 78H180.056C183.339 78 186 80.6612 186 83.9439V109H152V83.9439Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M192 94.9439C192 91.6612 194.661 89 197.944 89H220.056C223.339 89 226 91.6612 226 94.9439V109H192V94.9439Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M233 55.9439C233 52.6612 235.661 50 238.944 50H261.056C264.339 50 267 52.6612 267 55.9439V109H233V55.9439Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M274 104.944C274 101.661 276.661 99 279.944 99H301.056C304.339 99 307 101.661 307 104.944V109H274V104.944Z",
    fill: "#D9D9D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M314 24.9439C314 21.6612 316.661 19 319.944 19H342.056C345.339 19 348 21.6612 348 24.9439V109H314V24.9439Z",
    fill: "#D9D9D9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 28,
    r: 4,
    fill: "#8405DA",
    stroke: "white",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 48,
    r: 4,
    fill: "#8405DA",
    stroke: "white",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 5,
    r: 4,
    fill: "#8405DA",
    stroke: "white",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 78,
    r: 4,
    fill: "#8405DA",
    stroke: "white",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 89,
    r: 4,
    fill: "#8405DA",
    stroke: "white",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 50,
    r: 4,
    fill: "#8405DA",
    stroke: "white",
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 99,
    r: 4,
    fill: "#8405DA",
    stroke: "white",
    strokeWidth: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 331,
    cy: 19,
    r: 4,
    fill: "#8405DA",
    stroke: "white",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47 28L87 48L128 5L169 78L209 89L250 50L291 99L331 19",
    stroke: "#8405DA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagram);
export default __webpack_public_path__ + "static/media/diagram.116ea8f2bdc0a76968e8b010e8de1eb8.svg";
export { ForwardRef as ReactComponent };